import styled from 'styled-components';

export const DetailBox = styled.div`
  width: 100%;
  height: auto;
  border: 1px solid #70707026;
`;
